module.exports = __webpack_public_path__ + "img/holidey-mock-up.6475c935.jpg";